module.exports = {
    homepage: "https://www.delianac.com",
    root:"/delianacnew",
    apiUrl: "https://www.delianac.com",
};
